// src/components/Layout.js
import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSettings } from '../context/SettingsContext';
import {
  LayoutDashboard, Table2, UtensilsCrossed, Package,
  BarChart3, LogOut, Menu, X, Settings,
  Users, UserCheck, IndianRupee
} from 'lucide-react';

const adminNav = [
  { to:'/',          label:'Dashboard',     icon:LayoutDashboard },
  { to:'/tables',    label:'Tables',        icon:Table2          },
  { to:'/billing',   label:'Billing',       icon:IndianRupee     },
  { to:'/customers', label:'Customers',     icon:UserCheck       },
  { to:'/food',      label:'Menu & Orders', icon:UtensilsCrossed },
  { to:'/inventory', label:'Inventory',     icon:Package         },
  { to:'/reports',   label:'Reports',       icon:BarChart3       },
  { to:'/team',      label:'Team',          icon:Users           },
  { to:'/settings',  label:'Settings',      icon:Settings        },
];

const staffNav = [
  { to:'/',         label:'Dashboard', icon:LayoutDashboard },
  { to:'/tables',   label:'Tables',    icon:Table2          },
  { to:'/billing',  label:'Billing',   icon:IndianRupee     },
  { to:'/reports',  label:'Reports',   icon:BarChart3       },
  { to:'/settings', label:'Settings',  icon:Settings        },
];

export default function Layout() {
  const { user, logout, isAdmin } = useAuth();
  const { businessName, logoUrl } = useSettings();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const navItems = isAdmin ? adminNav : staffNav;
  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div className="layout">
      <aside className={`sidebar ${open ? 'sidebar-open' : ''}`}>
        {/* Logo / Business Name */}
        <div className="sidebar-logo">
          {logoUrl
            ? <img src={logoUrl} alt="logo" style={{ width:32, height:32, borderRadius:8, objectFit:'cover', flexShrink:0 }}/>
            : <div className="sidebar-logo-circle">🎱</div>
          }
          <span>{businessName}</span>
        </div>

        <nav className="sidebar-nav">
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} end={to==='/'} onClick={() => setOpen(false)}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <Icon size={18}/><span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <NavLink to="/settings" className="admin-info" onClick={() => setOpen(false)}>
            <div className="admin-avatar">{user?.username?.[0]?.toUpperCase()}</div>
            <div>
              <div className="admin-name">{user?.username}</div>
              <div className="admin-role">{user?.role === 'admin' ? 'Admin' : 'Staff'} · Click to edit</div>
            </div>
          </NavLink>
          <button className="logout-btn" onClick={handleLogout}><LogOut size={16}/> Logout</button>
        </div>
      </aside>

      {open && <div className="overlay" onClick={() => setOpen(false)}/>}

      <main className="main-content">
        <header className="topbar">
          <button className="hamburger" onClick={() => setOpen(!open)}>
            {open ? <X size={22}/> : <Menu size={22}/>}
          </button>
          <div className="topbar-title">{businessName}</div>
          {!isAdmin && <span className="staff-badge">Staff Mode</span>}
        </header>
        <div className="page-wrapper"><Outlet/></div>
      </main>
    </div>
  );
}
